import { Box, Button, CircularProgress, FormControl, Grid, Paper, Typography } from "@mui/material";
import { useSnackbar } from "notistack";

import { useNavigate } from "react-router-dom";


import { useEffect, useState } from "react";

import { format } from 'date-fns';
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useSelector } from "react-redux";
import { RootState } from "../../../app/store";

import configUrls from "../../../config/configUrls";
import { useGetProcessoAtribuicoesQuery } from "../processoApiSlice";
import { ProcessoAtribuirList } from "../../../types/processo/ProcessoAtribuirList";





export const ProcessoAtribuirListForm = () => {

    const { enqueueSnackbar, closeSnackbar } = useSnackbar()
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate(); // Hook para navegação


    const [atribuicoes, setAtribuicoes] = useState<ProcessoAtribuirList[]>([]);


    const { processoSelecionado } = useSelector((state: RootState) => state.processoSelecionado);
    useEffect(() => {
        if (!processoSelecionado) {
            alert("Nenhum processo selecionado");
            window.location.href = configUrls.PROCESSO_LIST_RT
        }
    }, [processoSelecionado]);


    const { data, isFetching, error } = useGetProcessoAtribuicoesQuery(processoSelecionado?.id ?? "");

    useEffect(() => {
        if (data) {
            setAtribuicoes(data);
        }
        if (error) {
            enqueueSnackbar("Atribuições não encontradas!", { variant: "error" });
        } else if (isFetching) {
            enqueueSnackbar("Buscando registros...", { variant: "info" });
        }
    }, [data, error, isFetching, enqueueSnackbar]);


    if (isFetching) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }
    const headerGerados = (
        <Typography variant="body2" color="textSecondary">
            Atribuições(s) encontrada(s): {atribuicoes.length}
        </Typography>
    );


    const renderData = (rowData: ProcessoAtribuirList) => {
        const dataCriacao = rowData.dataHora ? format(rowData.dataHora, 'dd/MM/yyyy HH:mm:ss') : "Data não disponível";
        return <Typography color="secondary" variant="body2">{dataCriacao}</Typography>;
    };

    const renderUsuario = (rowData: ProcessoAtribuirList) => (
        <Typography color="secondary" variant="body2">{rowData.responsavel?.nome || "Usuário não disponível"}</Typography>
    );
    const renderObservacao = (rowData: ProcessoAtribuirList) => (
        <Typography color="secondary" variant="body2">{rowData.observacao || ""}</Typography>
    );

    return (
        <>

            <Paper sx={{ width: "100%", height: "100vh", padding: "12px" }}>



                <Grid container padding={2}>
                    <Grid item xs={12}>
                        <FormControl fullWidth>


                            <Box display="flex" justifyContent="space-between" mb={2}>

                                <Box display="flex">
                                    <Typography color="secondary" variant="h6" gutterBottom>
                                        Atribuições para o processo: {processoSelecionado?.numeroProcesso}
                                    </Typography>
                                </Box>

                                <Box display="flex" justifyContent="flex-end" gap={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => { navigate(configUrls.PROCESSO_ATRIBUIR_CREATE_RT) }}
                                    >
                                        Novo
                                    </Button>

                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        onClick={() => navigate(-1)}
                                    >
                                        Voltar
                                    </Button>
                                </Box>
                            </Box>
                        </FormControl>
                    </Grid>
                </Grid>


                <DataTable
                    value={atribuicoes}
                    paginator
                    rows={25}
                    showGridlines={true}
                    size="small"
                    columnResizeMode="expand"
                    resizableColumns
                    dataKey="id"
                    header={headerGerados}
                    className="custom-datatable"
                >

                    <Column header="Data" body={renderData} sortable style={{ width: '15%' }} />
                    <Column header="Usuário" body={renderUsuario} sortable style={{ width: '15%' }} />
                    <Column header="Observação" body={renderObservacao} sortable style={{ width: '70%' }} />


                </DataTable>


            </Paper>










        </>







    );










};











